import React from "react";
import {Text, Image, useColorModeValue, Flex, Box} from "@chakra-ui/react";
import {CCarousel, CCarouselItem, CImage, CCarouselCaption} from "@coreui/react"
import Link from "./Link";
// import NewWindow from 'react-new-window';
// import AppLink from 'react-native-app-link';
import OpenApp from "react-open-app";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function BannerSlick(props) {
    const settings = {
        dots: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 10000,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
    };

	return (
        <>
            <Flex justifyContent={'space-around'}>
            <Box w='91%' px={'2'}>
            
                
                <Slider {...settings}>
                {props.banner.map((src,index) => (
                    <Link key={index} to={src.path}>
                        <div >
                            <Image  margin={'auto'} borderRadius='20px' src={src.banner}/>
                        </div>
                    </Link>
                    ))}
                </Slider>
                
            
            </Box>
            </Flex>
        </>
	);
}

export default BannerSlick;